import { copyExif } from "@utils/exif.util";
import { replaceFileExtension } from "@utils/file.util";

export class ImageResizeService {
  public static instance = new ImageResizeService();

  private constructor() {}

  resize(file: File, maxSize: number): Promise<File> {
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onload = (readerEvent) => {
        if (!readerEvent.target) {
          reject("Reader event target is not defined");
          return;
        }
        const image = new Image();

        image.onload = () => {
          if (image.width <= maxSize && image.height <= maxSize) {
            resolve(file);
            return;
          }
          const canvas = document.createElement("canvas");
          let width = image.width;
          let height = image.height;
          if (width > height) {
            if (width > maxSize) {
              height *= maxSize / width;
              width = maxSize;
            }
          } else {
            if (height > maxSize) {
              width *= maxSize / height;
              height = maxSize;
            }
          }
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext("2d");
          if (!context) {
            reject("Canvas context is not defined");
            return;
          }
          context.drawImage(image, 0, 0, width, height);
          canvas.toBlob(async (blob: Blob | null) => {
            if (!blob) {
              reject();
              return;
            }
            if ([".jpg", ".jpeg"].some((ext) => file.name.endsWith(ext))) {
              blob = await copyExif(file, blob);
            }
            resolve(
              new File([blob], replaceFileExtension(file.name, ".jpeg"), {
                type: "image/jpeg",
              }),
            );
          }, "image/jpeg");
        };

        image.src = readerEvent.target.result as string;
      };

      reader.readAsDataURL(file);
    });
  }
}
